<div class="container">
  <div class="row">
    <div class="col-md-10">
      <div class="panel panel-table">
        <div class="panel-heading">
          <h3 class="panel-title">DGX {{title}}</h3>
        </div>
        <div class="panel-body">
          <form [formGroup]="form">
            <div class="col-md-offset-11 col-md-1 format"><button tabindex=0 role=button class="btn btn-primary"
                (click)="backClicked();">Back</button></div>
            <div *ngIf="isLoading">
              <div class="spinner"></div>
            </div>
            <div class="form-group">
              <div *ngIf="ErrorResponse">
                <div>Error Parsing The Request:</div>
                <div>Code: {{code}}</div>
                <div>Msg: {{msg}}</div>
                <div>Line: {{line}}</div>
                <div>Validating against the schema</div>
              </div>
              <textarea aria-label ="Route XML content" formControlName="routeXmlContent" style="resize: none;" rows="50" readonly class="form-control"
                [innerHTML]='routeXmlResponse'> {{routeXmlResponse}} </textarea>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
